import { styled } from '@mui/material/styles'
import { Typography, Stack } from '@mui/material'

export const ReactionTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.colors.neutral.darkGray,
  marginRight: theme.spacing(1),
  fontStyle: 'italic',
}))

export const ReactionStackContainer = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  gap: theme.spacing(1),
  flexDirection: 'row',
  alignItems: 'center',
  [theme.breakpoints.up('mobile')]: {
    justifyContent: 'space-between',
  },
}))

export const ReactionIcon = styled('img')(({ theme }) => ({
  cursor: 'pointer',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(4),
  boxSizing: 'border-box',
  transition: 'transform 0.2s ease-in-out, background-color 0.2s ease-in-out',

  '&:hover': {
    backgroundColor: '#0C62FB1A',
    transform: 'scale(1.1)',
  },
}))
